<template>
  <a-card class='j-address-list-right-card-box' :loading='cardLoading' :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline'>
        <a-row :gutter='10'>

          <a-col :md='6' :sm='12'>
            <mtc-form-item label='label.name' style='margin-left:8px'>
              <a-input :placeholder="$t('label.pleaseEnterTheName')" v-model='queryParam.realname'></a-input>
            </mtc-form-item>
          </a-col>


          <a-col :md='6' :sm='12'>
            <mtc-form-item label='label.employeeID' style='margin-left:8px'>
              <a-input :placeholder="$t('label.pleaseEnterWorkNumber')" v-model='queryParam.workNo'></a-input>
            </mtc-form-item>
          </a-col>

          <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
            <a-col :md='6' :sm='24'>
             <!--<a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 18px">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
              <mtc-button @click='searchQuery' type='primary' icon='search' text='button.search'></mtc-button>
              <mtc-button @click='searchReset' type='primary' icon='reload' style='margin-left: 8px' text='button.reset'></mtc-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>

    <a-table
      ref='table'
      size='middle'
      bordered
      rowKey='userId'
      :pagination='ipagination'
      :columns='columns'
      :dataSource='dataSource'
      :loading='loading'
      @change='handleTableChange'>
      <template v-for='(item, index) in columns' :slot='item.slotName'>
        <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
        <mtcHeader :key='index' :text='item.slotName' />
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { positionList, queryByOrgCodeForAddressList } from '@api/api'

export default {
  name: 'AddressListRight',
  mixins: [JeecgListMixin],
  components: {},
  props: ['value'],
  data(){
    return {
      description: '用户信息',
      cardLoading: true,
      positionInfo: {},
      columns: [
        {
          title: '#',
          key: 'rowIndex',
          dataIndex: '',
          width: 60,
          align: 'center',
          customRender: ( t, r, i ) => parseInt(i) + 1
        },
        {
          slotName: 'label.name',
          // title: '姓名',
          width: '15%',
          align: 'center',
          dataIndex: 'realname',
          scopedSlots: { title: 'label.name' }
        },
        {
          slotName: 'label.employeeID',
          // title: '工号',
          width: '15%',
          align: 'center',
          dataIndex: 'workNo',
          scopedSlots: { title: 'label.employeeID' }
        },
        {
          slotName: 'label.department',
          // title: '部门',
          width: '20%',
          align: 'center',
          dataIndex: 'departName',
          scopedSlots: { title: 'label.department' }
        },
        {
          slotName: 'label.position',
          // title: '职务',
          width: '15%',
          align: 'center',
          dataIndex: 'post',
          customRender: ( text ) => (text || '').split(',').map(t => this.positionInfo[ t ]? this.positionInfo[ t ]: t).join(','),
          scopedSlots: { title: 'label.position' }
        },
        {
          slotName: 'label.cellPhone',
          // title: '手机',
          width: '15%',
          align: 'center',
          dataIndex: 'telephone',
          scopedSlots: { title: 'label.cellPhone' }
        },
        // {
        //   title: '手机号',
        //   width: '12%',
        //   align: 'center',
        //   dataIndex: 'phone'
        // },
        {
          slotName: 'label.eMail',
          // title: '公司邮箱',
          width: '15%',
          align: 'center',
          dataIndex: 'email',
          scopedSlots: { title: 'label.eMail' }
        }
      ],
    }
  },
  watch: {
    value: {
      immediate: true,
      handler( orgCode ){
        this.dataSource = []
        this.loadData(1, orgCode)
      }
    }
  },
  created(){
    this.queryPositionInfo()
  },
  methods: {

    loadData( pageNum, orgCode ){
      this.loading = true
      if (pageNum === 1) {
        this.ipagination.current = 1
      }
      // update-begin- --- author:wangshuai ------ date:20200102 ---- for:传过来的部门编码为空全查
      if (!orgCode) {
        queryByOrgCodeForAddressList({
          ...this.getQueryParams()
        }).then(( res ) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        }).finally(() => {
          this.loading = false
          this.cardLoading = false
        })
        // update-end- --- author:wangshuai ------ date:20200102 ---- for:传过来的部门编码为空全查
      } else {
        //加载数据 若传入参数1则加载第一页的内容
        queryByOrgCodeForAddressList({
          orgCode,
          ...this.getQueryParams()
        }).then(( res ) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        }).finally(() => {
          this.loading = false
          this.cardLoading = false
        })
      }
    },

    searchQuery(){
      this.loadData(1, this.value)
    },
    searchReset(){
      this.queryParam = {}
      this.loadData(1, this.value)
    },

    handleTableChange( pagination, filters, sorter ){
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' === sorter.order? 'asc': 'desc'
      }
      this.ipagination = pagination
      this.loadData(null, this.value)
    },

    // 查询职务信息
    queryPositionInfo(){
      positionList({ pageSize: 99999 }).then(res => {
        if (res.success) {
          let positionInfo = {}
          res.result.records.forEach(record => {
            positionInfo[ record[ 'code' ] ] = record[ 'name' ]
          })
          this.positionInfo = positionInfo
        }
      })
    }

  }
}
</script>
<style>
.j-address-list-right-card-box .ant-table-placeholder {
  min-height: 46px;
}
</style>
<style scoped>
.j-address-list-right-card-box {
  height: 100%;
  min-height: 300px;
}
</style>